import React, { useState, useEffect } from "react";
import { Button } from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { updateUserSoftEmail } from "../../../../Backend";
import { setUserCredentials } from "../../../../Reducer";
import { FormInput } from "../../../../Components";
import { getRole } from "../../../../Constants/Roles";
import { hasValue, isValidEmail } from "../../../../Helpers/validations/common";
import "./StudentProfilePage.scss";

export function StudentProfilePage() {
  const userData = useSelector((state) => state.user.credentials);
  const dispatch = useDispatch();
  const [t] = useTranslation();

  const [userInfo, setUserInfo] = useState({
    id: "",
    firstName: "",
    lastName: "",
    preposition: "",
    role: 0,
    schoolId: "",
    softEmail: "",
    course: "",
    class: "",
    iddinkCode: "",
    email: "",

    phoneNumber: "",
    address: "",
    postalCode: "",
    city: "",
    province: "",
    country: "",

    customerId: null,
    roleName: null,
    userName: null,
    isAdmin: false,
  });

  const [errorEmail, setErrorEmail] = useState(false);

  useEffect(() => {
    parseUserInfo();
  }, []);

  const parseUserInfo = () => {
    setUserInfo({ ...userInfo, ...userData, isAdmin: getRole(userInfo.role) });
  };

  const updateProfile = async () => {
    if (
      userData.softEmail !== userInfo.softEmail &&
      hasValue(userInfo.softEmail) &&
      isValidEmail(userInfo.softEmail)
    ) {
      var data = await updateUserSoftEmail(userInfo.softEmail);
      if (data.success) {
        dispatch(
          setUserCredentials({ ...userData, softEmail: userInfo.softEmail })
        );
      }
    } else {
      setErrorEmail(true);
      const delay = (ms) => new Promise((res) => setTimeout(res, ms));
      await delay(3000);
      setErrorEmail(false);
    }
  };

  return (
    <div className="student-profile-page">
      <div className="header">
        <span className="title">{t("ProfilePageTitle")}</span>
        <span className="description">{t("ProfilePageSubtitle")}</span>
      </div>
      <div className="block-info">
        <span className="subtitle">{t("StudentInfo")}</span>

        <div className="row-wrapper">
          <div className="input-wrapper">
            <span className="label">{t("ProfilePageName")}</span>
            <FormInput
              placeholder=""
              type="text"
              value={userInfo.firstName}
              disabled={true}
              change={(x) => setUserInfo({ ...userInfo, firstName: x })}
              update={() => updateProfile()}
            />
          </div>
          <div className="input-wrapper">
            <span className="label">{t("ProfilePageSurname")}</span>
            <FormInput
              placeholder=""
              type="text"
              value={userInfo.lastName}
              disabled={true}
              change={(x) => setUserInfo({ ...userInfo, lastName: x })}
              update={() => updateProfile()}
            />
          </div>
          <div className="input-wrapper">
            <span className="label">{t("ProfilePageSecondSurname")}</span>
            <FormInput
              placeholder=""
              type="text"
              value={userInfo.secondLastName}
              disabled={true}
              change={(x) => setUserInfo({ ...userInfo, secondLastName: x })}
              update={() => updateProfile()}
            />
          </div>
        </div>

        <div className="row-wrapper">
          <div className="input-wrapper">
            <span className="label">{t("ProfilePageCourse")}</span>
            <FormInput
              placeholder=""
              type="text"
              value={userInfo.course}
              disabled={true}
              change={(x) => setUserInfo({ ...userInfo, course: x })}
              update={() => updateProfile()}
            />
          </div>
          <div className="input-wrapper">
            <span className="label">{t("ProfilePageClass")}</span>
            <FormInput
              placeholder=""
              type="text"
              value={userInfo.class}
              disabled={true}
              change={(x) => setUserInfo({ ...userInfo, class: x })}
              update={() => updateProfile()}
            />
          </div>
          <div className="input-wrapper">
            <span className="label">{t("ProfilePageIddinkCode")}</span>
            <FormInput
              placeholder=""
              type="text"
              value={userInfo.iddinkCode}
              disabled={true}
              change={(x) => setUserInfo({ ...userInfo, iddinkCode: x })}
              update={() => updateProfile()}
            />
          </div>
        </div>
      </div>

      <div className="block-info">
        <span className="subtitle">{t("Contact")}</span>

        <div className="row-wrapper">
          <div className="input-wrapper">
            <span className="label">{t("ProfilePageEmail")}</span>
            <FormInput
              placeholder=""
              type="email"
              value={userInfo.softEmail}
              errorText={t("InvalidEmailFormat")}
              error={!isValidEmail(userInfo.softEmail)}
              change={(x) => setUserInfo({ ...userInfo, softEmail: x })}
              update={() => updateProfile()}
            />
          </div>
          <div className="input-wrapper">
            <span className="label">{t("ProfilePagePhoneNumber")}</span>
            <FormInput
              placeholder=""
              type="number"
              value={userInfo.phoneNumber}
              disabled={true}
              change={(x) => setUserInfo({ ...userInfo, phoneNumber: x })}
              update={() => updateProfile()}
            />
          </div>
          <div className="input-wrapper">
            <span className="label">{t("ProfilePageAddress")}</span>
            <FormInput
              placeholder=""
              type="text"
              value={userInfo.address}
              disabled={true}
              change={(x) => setUserInfo({ ...userInfo, address: x })}
              update={() => updateProfile()}
            />
          </div>
        </div>

        <div className="row-wrapper">
          <div className="input-wrapper">
            <span className="label">{t("ProfilePagePostalCode")}</span>
            <FormInput
              placeholder=""
              type="text"
              value={userInfo.postalCode}
              disabled={true}
              change={(x) => setUserInfo({ ...userInfo, postalCode: x })}
              update={() => updateProfile()}
            />
          </div>
          <div className="input-wrapper">
            <span className="label">{t("ProfilePageCity")}</span>
            <FormInput
              placeholder=""
              type="text"
              value={userInfo.city}
              disabled={true}
              change={(x) => setUserInfo({ ...userInfo, city: x })}
              update={() => updateProfile()}
            />
          </div>
          <div className="input-wrapper">
            <span className="label">{t("ProfilePageProvince")}</span>
            <FormInput
              placeholder=""
              type="text"
              value={userInfo.province}
              disabled={true}
              change={(x) => setUserInfo({ ...userInfo, province: x })}
              update={() => updateProfile()}
            />
          </div>
        </div>
      </div>

      <div className="button-wrapper">
        <Button className="save" onClick={() => updateProfile()}>
          {t("ProfilePageSaveBtn")}
        </Button>
      </div>
    </div>
  );
}
